import Swal from 'sweetalert2'

// Toast HAMESHA top-right (`top-end`) — phone pe bhi. Reference panel mobile pe bhi
// right side me hi dikhata hai (user ka phone screenshot, 2026-09-21). Pehle phone pe
// top-center tha; dobara responsive mat karna.
const baseOptions = {
    toast: true,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
    }
}

// Same call shape as a Swal mixin (`Toast.fire({ icon, title })`). `position` options
// ke BAAD aata hai taaki koi caller galti se centre/left na kar sake.
const Toast = {
    fire: (options) =>
        Swal.fire({ ...baseOptions, ...options, position: 'top-end' })
}

export default Toast;
